const { InnerBlocks, InspectorControls } = wp.blockEditor;
const { PanelBody, PanelRow } = wp.components;
import ImageControl from '../../wp-controlers/mediaUpload';

export default ({ attributes, setAttributes }) => {
  const { cardImage } = attributes;

  return (
    <>
      <InspectorControls>
        <PanelBody title="Conteúdo do Bloco" initialOpen={true}>
          <PanelRow>
            <ImageControl
              image="cardImage"
              attributes={attributes}
              setAttributes={setAttributes}
            />
          </PanelRow>
        </PanelBody>
      </InspectorControls>

      <div className="about-us-cards-swiper__card">
        <img
          src={cardImage.src}
          className="about-us-cards-swiper__card--image"
        />
        <InnerBlocks
          template={[
            [
              'core/heading',
              { className: 'about-us-cards-swiper__card--heading' },
            ],
            [
              'core/paragraph',
              { className: 'about-us-cards-swiper__card--content' },
            ],
          ]}
          templateLock="all"
        />
      </div>
    </>
  );
};
